import { gql } from "@apollo/client";

export const CREATE_PROFESIONAL_MONITOREO = gql`
    mutation CreateProfesionalMonitoreo($input: SaveProfesionalMonitoreoInput!) {
  createProfesionalMonitoreo(input: $input) {
    idProfesionalMonitoreo
  }
}
`;